<template>
    <a
        class="l-ss-c-offer"
        :class="{
            'l-ss-c-offer-vertical': isVertical,
            'l-ss-c-offer-mobile': mobile ,
            'l-ss-c-offer-not-available': !offer.available,
            'l-ss-c-offer-row-layout': offerLayout === 'row',
            'l-ss-c-offer-row-mini': offerLayout === 'rowMini',
            'l-ss-c-offer-column-mini': offerLayout === 'columnMini'
        }"
        :data-first-offer-id="offer.id"
        :data-offer-id="currentOffer.id"
        :data-offer-index="offerIndex"
        :href="currentOffer.url"
        :target="linkTargetBlank ? '_blank' : '_self'"
        @click="onclick">

        <offer-item
            v-for="contentItem in offerContentItems"
            :key="contentItem.key"
            :content-item="contentItem"/>
    </a>
</template>

<script>
    import { ref, onBeforeUnmount, onMounted } from '@vue/composition-api';
    import useOfferItemsResolver from '@/core/components/offer/use-offer-items-resolver';

    import useOfferGetPriceController from '@/core/components/offer/offer-price/use-offer-get-price-controller';

    import OfferItem from '@/core/components/offer/offer-item.vue';

    import { nanoid } from 'nanoid';

    export default {
        components: {
            OfferItem,
        },
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
                required: true,
            },
            layout: {
                type: String,
                default: 'row',
            },
            offerIndex: {
                type: Number,
                required: true,
            },
            mobile: {
                type: Boolean,
                default: false,
            },
            linkTargetBlank: {
                type: Boolean,
                default: false,
            },
            isCartCountAvailable: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { emit, root }) {
            const { offer, settings } = props;
            const { layout: layoutSettings, cart: cartSettings } = settings;

            const currentOffer = ref(offer);

            const isShowDropdown = ref();

            let offerLayout = props.layout;
            let isVertical = offerLayout === 'column' || offerLayout === 'columnMini';
            let isMini = offerLayout === 'columnMini' || offerLayout === 'rowMini';

            const contentSettings = layoutSettings[offerLayout];

            let destroyComponentsFunc = null;

            const offerCartId = nanoid();

            const initOfferContentItems = (rerender) =>
                useOfferItemsResolver(
                    {
                        items: contentSettings,
                        offer: currentOffer.value,
                        firstOfferId: offerCartId,
                        offerSettings: {
                            ...settings,
                            mobile: props.mobile,
                            vertical: isVertical,
                            isCartCountAvailable: props.isCartCountAvailable,
                            isShowDropdown,
                        },
                        on: {
                            addToCartClick: (event) => emit('add-to-cart-click', event),
                            removeFromCartClick: (event) => emit('remove-from-cart-click', event),
                            addToFavouritesClick: (event) => emit('add-to-favourites-click', event),
                            removeFromFavouritesClick: (event) => emit('remove-from-favourites-click', event),
                            changeOffer: (event) => onChangeOfferByParam(event),
                            loadGroupedOffers: (event) => emit('load-grouped-offers', event),
                            similarClickHandler: (data) => similarClickHandler(data),
                        },
                        root,
                        rerender,
                    });

            const offerContentItems = ref([]);

            const init = (rerender) => {
                const { destroyComponents, contentItems } = initOfferContentItems(rerender);
                offerContentItems.value = contentItems;
                destroyComponentsFunc = destroyComponents;
            };

            onMounted(() => {
                init();
            });

            onBeforeUnmount(() => {
                destroyComponentsFunc();
            });

            const onclick = (event) => {
                if (event.target.closest('.l-ss-c-offer-cart-btn')) {
                    return;
                }

                emit('click', event);
            };

            const updatePrice = async () => {
                const priceData = await useOfferGetPriceController(offer.id, settings.getPrice);
                currentOffer.value = {
                    ...currentOffer.value,
                    price: priceData.price,
                    oldPrice: priceData.oldPrice,
                };

                init(['price', 'labels']);
            };

            if (settings.getPrice) {
                updatePrice();
            }

            const similarClickHandler = (data) => {
                isShowDropdown.value = data;
            };

            const onChangeOfferByParam = (offer) => {
                currentOffer.value = offer;
                init(true);
            };

            return {
                currentOffer,
                cartSettings,
                offerContentItems,
                isVertical,
                offerLayout,
                isMini,
                onclick,
            };
        },
    };

</script>
